import { render, staticRenderFns } from "./ShowApprovalRequest.vue?vue&type=template&id=e5e67c28"
import script from "./ShowApprovalRequest.vue?vue&type=script&lang=js"
export * from "./ShowApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports